module.exports = __webpack_public_path__ + "static/media/infoSvg.7c935852.svg";